import styled from '@emotion/styled'
import {css} from '@emotion/react'
import {theme} from '../../theme'

const variantStyles = ({variant = 'default'}) => {
  switch (variant) {
    case 'pill':
      return css`
        border-radius: 999px;
      `
    case 'underline':
      return css`
        background: none;
        border-bottom: 1px solid ${theme.colors.border.tertiary};
        border-radius: 0;
        padding: 0;
        gap: 0;
      `

    case 'due':
      return css`
        background: none;
        padding: 0;
        gap: 0;
        border: 1px solid ${theme.colors.border.default};
        border-radius: ${theme.radii.md};
        overflow: hidden;
        width: 100%;
      `

    case 'pillFilled':
      return css`
        border-radius: 999px;
        background: #dde1eac2;
        padding: 2px 4px;
        gap: 0;
      `

    default:
      return css`
        border-radius: ${theme.radii.md};
      `
  }
}

const sizeStyles = ({size = 'md', variant}) => {
  if (variant === 'due' || variant === 'pillFilled') return css``
  switch (size) {
    case 'sm':
      return css`
        height: 28px;
        font-size: ${theme.fontSizes.xs};
      `
    case 'lg':
      return css`
        height: 40px;
        font-size: ${theme.fontSizes.md};
      `
    case 'md':
    default:
      return css`
        height: 32px;
        font-size: ${theme.fontSizes.sm};
      `
  }
}

export const ToggleWrapper = styled.div`
  display: ${({fullWidth}) => (fullWidth ? 'flex' : 'inline-flex')};
  width: ${({fullWidth}) => (fullWidth ? '100%' : 'auto')};
  align-items: center;
  background: ${theme.colors.bg.secondary};
  padding: 3px;
  gap: 2px;

  ${variantStyles}
`

const tabVariantStyles = ({
  variant = 'default',
  isActive,
  showActiveBorder = true,
}) => {
  if (variant === 'underline') {
    return css`
      border-radius: 0;
      border: none;
      background: none;
      color: ${isActive ? '#0327a9' : theme.colors.text.secondary};
      font-weight: ${isActive ? 700 : 400};
      position: relative;

      ${isActive &&
      css`
        &::after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 0;
          right: 0;
          height: 2px;
          background: #0327a9;
          border-radius: 2px;
        }
      `}
    `
  }

  if (variant === 'pillFilled') {
    return css`
      border-radius: 999px;
      border: none;
      background: ${isActive
        ? 'radial-gradient(57.14% 57.14% at 50% 92.86%, #5378FC 0%, #29355D 100%)'
        : 'none'};
      box-shadow: ${isActive ? '0px 3px 5.3px 0px #0000002E' : 'none'};
      color: ${isActive ? '#ffffff' : '#3D5199'};
      font-family: 'Inter', Regular;
      font-weight: ${isActive ? 700 : 400};
      font-size: 12px;
      line-height: 100%;
      letter-spacing: 0%;
      height: auto;
      padding-block: 10px;

      gap: ${isActive ? '12px' : '6px'};
      angle: 0 deg;
      padding-top: 10px;
      padding-right: 20px;
      padding-bottom: 10px;
      padding-left: 20px;
    `
  }

  if (variant === 'due') {
    return css`
      flex: 1;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      padding: 10px 12px;
      border-radius: 0;
      background: none;
      border: none;
      border-right: 1px solid ${theme.colors.border.default};
      border-bottom: ${isActive
        ? '2px solid #E87722'
        : '2px solid transparent'};
      font-weight: 400;
      height: auto;
      white-space: normal;
      text-align: left;

      &:last-of-type {
        border-right: none;
      }
    `
  }

  return css`
    border-radius: ${variant === 'pill' ? '999px' : '5px'};
    background: ${isActive ? '#ffffff' : 'none'};
    color: ${isActive ? '#0327a9' : theme.colors.text.secondary};
    font-weight: ${isActive ? 700 : 400};
    box-shadow: ${isActive ? '0px 1px 2px 0px #0000001a' : 'none'};
    border: ${isActive && showActiveBorder ? '1px solid #0327a9' : 'none'};
  `
}

export const ToggleTab = styled.button`
  display: inline-flex;
  flex: ${({fullWidth}) => (fullWidth ? 1 : 'none')};
  align-items: center;
  justify-content: center;
  gap: ${theme.space[1.5]};
  padding: 0 ${theme.space[3]};
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: background ${theme.transitions.normal},
    color ${theme.transitions.normal};

  &:hover:not([aria-selected='true']) {
    color: ${theme.colors.text.primary};
  }

  ${sizeStyles}
  ${tabVariantStyles}
`
